import { render, staticRenderFns } from "./LandPage.vue?vue&type=template&id=81802938&scoped=true"
import script from "./LandPage.vue?vue&type=script&lang=js"
export * from "./LandPage.vue?vue&type=script&lang=js"
import style0 from "./LandPage.vue?vue&type=style&index=0&id=81802938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81802938",
  null
  
)

export default component.exports